var _path, _path2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg24(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.68995 28.4759V21.7559C6.85795 17.0759 10.3859 13.1879 15.0179 12.5639C15.0179 12.5639 16.4819 12.4199 16.4579 12.4199C19.2419 11.7479 22.6739 9.92393 24.6659 7.93193L28.0739 4.52393L27.4259 4.71593C23.5139 6.01193 19.4579 6.94793 15.3539 7.45193C8.77795 8.26793 3.64195 13.5719 3.01795 20.1719L2.89795 21.2999V28.4999H6.68995V28.4759Z",
    fill: "#FAB215"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.0739 4.524L24.6659 7.932C22.6499 9.924 19.2419 11.748 16.4579 12.42C12.7619 13.452 10.0259 16.764 9.88187 20.58V24.996C9.88187 26.316 8.96987 27.468 7.69787 27.972L6.71387 28.476H12.8579C21.2819 28.476 28.1219 21.636 28.1219 13.236V4.5L28.0739 4.524Z",
    fill: "url(#paint0_linear_887_4787)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_887_4787",
    x1: 36,
    y1: 12.5,
    x2: 12,
    y2: 33.5,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0.147013,
    stopColor: "#FAB215",
    stopOpacity: 0.85
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#FAB215",
    stopOpacity: 0.4
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg24);
export default __webpack_public_path__ + "static/media/24.2b4f5cb15595f67ce6745ca17d083287.svg";
export { ForwardRef as ReactComponent };